import { FacturationNetStatus } from "../FacturationNetStatus";

class BillingFacturationNetResponse {
    public ClaimId: string;
    public Status: FacturationNetStatus;
    public BillDate: Date;
    public CreationDate: Date;
    public LastModificationDate: Date;
    public CreatedByEmployeeId: string;
    public Codes: string;
    public PreAmount: string;
    public Amount: string;
    public EncounterId: string;

    public static getStatusLabel(status: FacturationNetStatus): string {
        switch (status) {
            case FacturationNetStatus.NoStatus:
                return "New";
            case FacturationNetStatus.Valid:
                return FacturationNetStatus[status];
            case FacturationNetStatus.Invalid:
                return FacturationNetStatus[status];
            case FacturationNetStatus.RAMQCancelled:
                return FacturationNetStatus[status];
            case FacturationNetStatus.RAMQReceived:
                return FacturationNetStatus[status];
            case FacturationNetStatus.WaitingToSendRAMQ:
                return FacturationNetStatus[status];
            case FacturationNetStatus.ToBeCancelled:
                return FacturationNetStatus[status];
            case FacturationNetStatus.RAMQCancelled:
                return FacturationNetStatus[status];
            default:
                return FacturationNetStatus[status];
        }
    }

    public static getBillDisplayString(bill: BillingFacturationNetResponse): string {
        let amount = "";
        if (sessionStore.getCurrentEmployee().ContactFacetId == bill.CreatedByEmployeeId) {
            if (!IsNullOrWhiteSpace(bill.PreAmount))
                amount = `- ~${bill.PreAmount}$`;
            if (!IsNullOrWhiteSpace(bill.Amount))
                amount = `- ${bill.Amount}$`;
        }

        return `FNET ${bill.Codes} (${BillingFacturationNetResponse.getStatusLabel(bill.Status)}) ${amount}`;
    }

    public static canCancelBill(bill: BillingFacturationNetResponse): boolean {
        return bill.Status === FacturationNetStatus.NoStatus
            || bill.Status === FacturationNetStatus.Valid
            || bill.Status === FacturationNetStatus.Invalid;
    }
}

class FacturationNetClaimInfo {
    public ClaimId: string;
    public ClaimStatus: FacturationNetStatus;
    public Codes: string;
    public PreAmount: string;
    public Amount: string;
}

export { BillingFacturationNetResponse, FacturationNetClaimInfo };
